import { render, staticRenderFns } from "./CharacteristicsList.vue?vue&type=template&id=fbcc992e&scoped=true&"
import script from "./CharacteristicsList.vue?vue&type=script&lang=js&"
export * from "./CharacteristicsList.vue?vue&type=script&lang=js&"
import style0 from "./CharacteristicsList.vue?vue&type=style&index=0&id=fbcc992e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcc992e",
  null
  
)

export default component.exports